import APIService from "@/services/APIService.js";

export default {
    getJoa(){
        return APIService.apiCall().get("/Joa/getJoa");
    },
    salvar(postData){
        return APIService.apiCall().post(`/Joa/salvar`,JSON.stringify(postData));
    }
}